import { createRouter, createWebHistory } from 'vue-router'
import { useVendaStore } from '../stores/vendaStore'
import { useAuthStore } from '../stores/authStore'
import { useFamiliaAuthStore } from '../stores/familiaAuthStore'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { public: true, title: 'Login' }
  },
  // ─── PORTAL DOS PAIS ───
  {
    path: '/portal',
    name: 'PortalFamiliaLogin',
    component: () => import('../views/PortalFamiliaLogin.vue'),
    meta: { public: true, portal: true, title: 'Portal dos Pais' }
  },
  {
    path: '/portal/inicio',
    name: 'FamiliaPortal',
    component: () => import('../views/FamiliaPortal.vue'),
    meta: { portal: true, title: 'Meus Filhos' }
  },
  {
    path: '/portal/filho/:id',
    name: 'FamiliaFilhoDetalhes',
    component: () => import('../views/FamiliaFilhoDetalhes.vue'),
    meta: { portal: true, title: 'Detalhes do Aluno' },
    props: true
  },
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/DashboardInteligente.vue'),
    meta: {
      title: 'Dashboard',
      group: 'principal',
      icon: `<svg viewBox="0 0 20 20" fill="currentColor"><path d="M2 10a8 8 0 1116 0A8 8 0 012 10zm8-5a1 1 0 00-1 1v3H6a1 1 0 000 2h3v3a1 1 0 002 0v-3h3a1 1 0 000-2h-3V6a1 1 0 00-1-1z" clip-rule="evenodd" fill-rule="evenodd"/></svg>`,
      iconPath: `<path d="M3 4a1 1 0 011-1h5a1 1 0 011 1v5a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm0 9a1 1 0 011-1h5a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm9-9a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1V4zm0 8a1 1 0 011-1h3a1 1 0 011 1v5a1 1 0 01-1 1h-3a1 1 0 01-1-1v-5z"/>`
    }
  },
  {
    path: '/caixa',
    name: 'CaixaRapido',
    component: () => import('../views/CaixaRapido.vue'),
    meta: {
      title: 'Caixa Rápido',
      group: 'principal',
      iconPath: `<path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z"/><path fill-rule="evenodd" d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z" clip-rule="evenodd"/>`
    }
  },
  {
    path: '/clientes',
    name: 'Clientes',
    component: () => import('../views/Clientes.vue'),
    meta: {
      title: 'Clientes',
      group: 'cadastros',
      iconPath: `<path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>`
    }
  },
  {
    path: '/clientes/:id/editar',
    name: 'EditarCliente',
    component: () => import('../views/Clientes.vue'),
    meta: { title: 'Editar Cliente', group: null },
    props: true
  },
  {
    path: '/produtos',
    name: 'CadastroProduto',
    component: () => import('../views/CadastroProduto.vue'),
    meta: {
      title: 'Produtos',
      group: 'cadastros',
      iconPath: `<path fill-rule="evenodd" d="M10 2a4 4 0 00-4 4v1H5a1 1 0 00-.994.89l-1 9A1 1 0 004 18h12a1 1 0 00.994-1.11l-1-9A1 1 0 0015 7h-1V6a4 4 0 00-4-4zm2 5V6a2 2 0 10-4 0v1h4zm-6 3a1 1 0 112 0 1 1 0 01-2 0zm7-1a1 1 0 100 2 1 1 0 000-2z" clip-rule="evenodd"/>`
    }
  },
  {
    path: '/produtos/:id/editar',
    name: 'EditarProduto',
    component: () => import('../views/CadastroProduto.vue'),
    meta: { title: 'Editar Produto', group: null },
    props: true
  },
  {
    path: '/quitacao',
    name: 'QuitarDivida',
    component: () => import('../views/QuitarDivida.vue'),
    meta: {
      title: 'Quitar Dívida',
      group: 'financeiro',
      iconPath: `<path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z"/>`
    }
  },
  {
    path: '/quitacao/:clienteId',
    name: 'QuitarDividaCliente',
    component: () => import('../views/QuitarDivida.vue'),
    meta: { title: 'Quitar Dívida', group: null },
    props: true
  },
  {
    path: '/fechamento',
    name: 'FechamentoCaixa',
    component: () => import('../views/FechamentoCaixa.vue'),
    meta: {
      title: 'Fechamento',
      group: 'financeiro',
      iconPath: `<path fill-rule="evenodd" d="M6 2a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V7.414A2 2 0 0015.414 6L12 2.586A2 2 0 0010.586 2H6zm2 10a1 1 0 10-2 0v3a1 1 0 102 0v-3zm2-3a1 1 0 011 1v5a1 1 0 11-2 0v-5a1 1 0 011-1zm4-1a1 1 0 10-2 0v7a1 1 0 102 0V8z" clip-rule="evenodd"/>`
    }
  },
  {
    path: '/terminais',
    name: 'GerenciarTerminais',
    component: () => import('../views/GerenciarTerminais.vue'),
    meta: {
      title: 'Maquininhas',
      group: 'sistema',
      iconPath: `<path fill-rule="evenodd" d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z" clip-rule="evenodd"/>`
    }
  },
  {
    path: '/teste-rede',
    name: 'TesteRede',
    component: () => import('../views/TesteRede.vue'),
    meta: {
      title: 'Integração Rede',
      group: 'sistema',
      iconPath: `<path fill-rule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clip-rule="evenodd"/>`
    }
  },
  {
    path: '/portal-pais',
    name: 'PortalPais',
    component: () => import('../views/PortalPais.vue'),
    meta: {
      title: 'Portal dos Pais',
      group: 'sistema',
      iconPath: `<path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z"/>`
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: {
      template: `<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:60vh;gap:16px"><h1 style="font-size:3rem;font-weight:800;color:#0f172a">404</h1><p style="color:#64748b">Página não encontrada</p><router-link to="/" style="padding:10px 24px;background:#16a34a;color:#fff;border-radius:8px;text-decoration:none;font-weight:600">Voltar ao Dashboard</router-link></div>`
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} — Cantina Escolar` : 'Cantina Escolar'

  const auth = useAuthStore()
  const familiaAuth = useFamiliaAuthStore()

  // ── Rotas do portal dos pais ──
  if (to.meta.portal) {
    // Se não está autenticado como pai e a rota não é pública → login do portal
    if (!to.meta.public && !familiaAuth.isPaiAuthenticated) {
      return next({ name: 'PortalFamiliaLogin' })
    }
    // Se está na tela de login do portal mas já autenticado → início
    if (to.name === 'PortalFamiliaLogin' && familiaAuth.isPaiAuthenticated) {
      return next({ name: 'FamiliaPortal' })
    }
    return next()
  }

  // ── Rotas normais do sistema ──
  if (!to.meta.public && !auth.isAuthenticated) {
    return next({ name: 'Login' })
  }

  if (to.name === 'Login' && auth.isAuthenticated) {
    return next({ name: 'Dashboard' })
  }

  const store = useVendaStore()
  if (navigator.onLine && store.hasPendingSync && !store.isSyncing) {
    store.syncPendingSales().catch(err => console.error('Sync error:', err))
  }

  next()
})

export default router
